<!-- eslint-disable no-console -->
<template>
  <div>
    <b-modal no-close-on-backdrop no-close-on-esc v-model="show" size="md" header-class="my-class"
        ref="modal-inser-user" @close="closeModal()" title-class="font-18">
      <template #modal-header="{ close }" class="bg-dark">
        <!-- Emulate built in modal header close button action -->
        <p class="w-100 pt-3 text-center text-white h-100" size="sm" disabled variant="outline-danger">
          {{ titleModalEdit }}
        </p>
      </template>
      <div class="row mt-2">
        <div class="col-4 text-center">
          <img :src="video.thumbnail" alt="" style="width: 100%;height: auto;"/>
        </div>
        <div class="col-8">
          <b-form-group class="" label-for="name">
            <label class="text-label">
              テロップ１ <span
                class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <b-form-input v-model.trim="video.name" for="name" type="text" placeholder="テロップ１"
                @input="clearError('name', video.name)" />
            <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
          </b-form-group>
        </div>
        <div class="col-12 mt-2">
          <b-form-group class="mb-3" label-for="caption">
            <label class="text-label">テロップ２</label>
            <b-form-input v-model.trim="video.caption" for="caption" type="text" placeholder="テロップ２"/>
          </b-form-group>
        </div>
        <div class="col-6 mt-2">
          <b-form-group class="mb-3" label-for="met">
            <label class="text-label">MET’ｓ換算</label>
            <b-form-input v-model="video.met" for="met" type="text" placeholder="MET’ｓ換算"
                @input="clearError('met', video.met)" />
            <div class="text-danger" v-if="errors.met">{{ errors.met }}</div>
          </b-form-group>
        </div>
        <div class="col-6 mt-2">
          <b-form-group class="mb-3" label-for="duration">
            <label class="text-label">動画再生時間</label>
            <b-form-input :value="video.duration" disabled for="code" type="text" placeholder="動画再生時間"/>
          </b-form-group>
        </div>
        <template v-for="category in categories">
          <div class="col-12 mt-2" v-if="category.id === 3" :key="category.id">
            <b-form-group class="mb-3">
              <h6 class="text-label">{{ category.name }} ({{ category.children.map(i => i.text).join(', ') }})</h6>
              <b-form-checkbox-group v-model="video.weekdays" :options="getJpWeekDayOptions()" class="weekday-option"/>
            </b-form-group>
          </div>
          <div class="col-12 mt-2" v-else :key="category.id">
            <b-form-group class="mb-3">
              <h6 class="text-label">{{ category.name }}</h6>
              <b-form-checkbox-group v-model="video.categories" :options="category.children"/>
            </b-form-group>
          </div>
        </template>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button @click="closeModal()" variant="outline-danger" style="margin-left: 5px" class="float-end w-lg">
            キャンセル
          </b-button>
          <b-button @click="submit()"
              type="button" class="float-end btn-lyg w-lg btn-capture"> アップロード
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mixin } from '../../helpers/Vue-Mixin';
import api from '@/api';

export default {
  props: ['show', 'item'],

  data () {
    return {
      titleModalEdit: '動画編集',
      video: this.cloneItem(this.item),
      categories: [],
      errors: this.resetErrors(),
    }
  },

  mixins: [mixin],

  watch: {
    item: {
      handler (value) {
        this.video = this.cloneItem(value);
      },
    },
  },

  async created () {
    await this.getGroupedCategoryOptions();
  },

  methods: {
    cloneItem (item) {
      return JSON.parse(JSON.stringify(item));
    },

    resetErrors() {
      return {
        name: '',
        met: '',
      };
    },

    clearError(field, value) {
      if (value !== null && value !== '' && value !== undefined) {
        this.errors[field] = '';
      }
    },

    validated() {
      let valid = true;
      this.errors = this.resetErrors();

      if (this.video.name === null || this.video.name === '') {
        this.errors['name'] = 'テロップ１がりテストを選択してください';
        valid = false;
      }

      if (isNaN(Number(this.video.met))) {
        this.errors['met'] = '立ち上がりテストを選択してください';
        valid = false;
      }

      return valid;
    },

    async getGroupedCategoryOptions() {
      const res = await api.getCategories();
      const categories = res.data;
      this.categories = categories.map(i => {
        i.children = i.children.map(j => ({text: j.name, value: j.id}));
        return i;
      });
    },

    getJpWeekDayOptions() {
      return [
        {text: '月', value: 1},
        {text: '火', value: 2},
        {text: '水', value: 3},
        {text: '木', value: 4},
        {text: '金', value: 5},
      ];
    },

    closeModal () {
      this.$emit('close');
    },

    async submit () {
      if (!this.validated()) {
        return;
      }

      this.closeModal();

      try {
        await api.updateVideo(this.video.id, this.video);
        window.toastr.success("動画アップロード が完了しました。");
        this.$emit('edited', this.cloneItem(this.video));
      } catch (error) {
        // eslint-disable-next-line no-console
        window.toastr.error("動画が長すぎます");
        console.error(error);
      }
    },
  },
}
</script>

<style scoped>
::v-deep .my-class {
  background: #395299;
  color: white;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
  height: 70px;
  line-height: 18px;
}

::v-deep .custom-control-label {
  margin-left: 1.25em;
}

.disabled {
  pointer-events: none;
  cursor: default;
}

::v-deep .custom-control-inline {
  display: inline-block;
  width: 150px;
}

::v-deep .weekday-option .custom-control-inline {
  width: 75px;
}

::v-deep .bxs-cloud-upload {
  color: #d3d3d3 !important;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  font-family: "Noto Sans JP";
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

::-webkit-input-placeholder {
  font-family: "Noto Sans JP";
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

::v-deep .btn-secondary {
  color: #8fc31f !important;
  border-color: #8fc31f !important;
  background: #ffffff !important;
}

.text-label {
  font-weight: 500 !important;
  color: #404040;
}

.text-label-required {
  font-weight: 500 !important;
  color: #f5f5f5;
}

.bg-required-label {
  background: #ff5858 !important;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}

::v-deep .dropzone.dz-clickable {
  pointer-events: none;
  cursor: default;
}

.btn-capture {
  color: #ffffff !important;
  background-color: #395299 !important;
  border-color: #395299 !important;
}

.btn-capture:hover {
  background: #395299 !important;
}
</style>